/**
 * LogoImage — responsive logo with AVIF/WebP/PNG variants.
 * Uses <picture> with explicit width/height to prevent layout shift (CLS).
 */

interface LogoImageProps {
  size?: 64 | 128 | 256;
  className?: string;
  alt?: string;
  ariaHidden?: boolean;
}

export function LogoImage({ size = 64, className, alt = 'Athena', ariaHidden }: LogoImageProps) {
  return (
    <picture>
      <source type="image/avif" srcSet={`/logo-${size}.avif`} />
      <source type="image/webp" srcSet={`/logo-${size}.webp`} />
      <img
        src={`/logo-${size}.png`}
        width={size}
        height={size}
        alt={ariaHidden ? '' : alt}
        aria-hidden={ariaHidden ? true : undefined}
        loading={size <= 64 ? 'eager' : 'lazy'}
        decoding="async"
        className={className}
      />
    </picture>
  );
}
